import React, { useEffect, useState } from "react";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import CoursesPage from "./components/CoursePage";
import Courses from "./components/Courses";
import CourseDetail from "./components/CourseDetail";
import { getCourseBySlug } from "./data/courseDetails";
import Footer from "./components/Footer";
import Reviews from "./components/Reviews";
import Contact from "./components/Contact";
import About from "./components/About";
import Blog from "./components/Blog";
import BlogPost from "./components/BlogPost";
import FAQ from "./components/FAQ";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import PageSEO from "./components/PageSEO";
import "./App.css";



function HomePage({ navigate }) {
  return (
    <>
      <Hero />
      <Courses navigate={navigate} />
      <Reviews animated />
      <About navigate={navigate} embedded />
      <Blog embedded navigate={navigate} />
      <FAQ />
      <Contact />
    </>
  );
}

// function App() {
//   const [path, setPath] = useState(window.location.pathname);

//   useEffect(() => {
//     const handlePopState = () => setPath(window.location.pathname);

//     window.addEventListener("popstate", handlePopState);
//     return () => window.removeEventListener("popstate", handlePopState);
//   }, []);



 

//   const renderPage = () => {
//     if (path === "/about") {
//       return <><About /><Footer /></>;
//     }
//      if (path === "/courses") {
//     return (
//       <>
//         <CoursesPage />
//         <Footer />
//       </>
//     );
//   }
//     if (path === "/faq") {
//       return <><FAQ /><Footer /></>;
//     }

//     if (path === "/reviews") {
//       return <><Reviews /><Footer /></>;
//     }

//     if (path === "/contact") {
//       return <><Contact /><Footer /></>;
//     }
// if (path === "/privacy-policy") {
//   return <><PrivacyPolicy /><Footer /></>;
// }

// if (path === "/terms") {
//   return <><TermsOfService /><Footer /></>;
// }
//     return <HomePage />;
//   };

//   return (
//     <>
//       <Navbar currentPath={path} />
//       {renderPage()}
//     </>
//   );
// }

// export default App;

function App() {
  const [path, setPath] = useState(window.location.pathname);
  const [hash, setHash] = useState(window.location.hash);

  useEffect(() => {
    const syncLocation = () => {
      setPath(window.location.pathname);
      setHash(window.location.hash);
    };
    window.addEventListener("popstate", syncLocation);
    window.addEventListener("hashchange", syncLocation);
    return () => {
      window.removeEventListener("popstate", syncLocation);
      window.removeEventListener("hashchange", syncLocation);
    };
  }, []);

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const scrollToTarget = () => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
      };
      requestAnimationFrame(scrollToTarget);
      const timer = window.setTimeout(scrollToTarget, 120);
      return () => window.clearTimeout(timer);
    }
    window.scrollTo(0, 0);
  }, [path, hash]);

  const navigate = (nextPath) => {
    const hashIndex = nextPath.indexOf("#");
    const nextRoute = hashIndex >= 0 ? nextPath.slice(0, hashIndex) || "/" : nextPath;
    const nextHash = hashIndex >= 0 ? nextPath.slice(hashIndex) : "";
    const url = nextHash ? `${nextRoute}${nextHash}` : nextPath;

    window.history.pushState({}, "", url);
    setPath(nextRoute);
    setHash(nextHash);
  };

  const hideLayout = path === "/privacy-policy" || path === "/terms";

  const courseMatch = path.match(/^\/courses\/([^/]+)$/);
  const courseSlug = courseMatch?.[1];
  const course = courseSlug ? getCourseBySlug(courseSlug) : null;
  const scrollTarget = hash;

  const renderPage = () => {
    if (courseSlug) {
      if (!course) {
        return (
          <section style={{ padding: "120px 20px", textAlign: "center", color: "#fff" }}>
            <h1>Course not found</h1>
            <button type="button" className="btn-primary" onClick={() => navigate("/courses")}>
              Back to courses
            </button>
          </section>
        );
      }
      return <CourseDetail course={course} navigate={navigate} scrollTarget={scrollTarget} />;
    }
    if (path === "/about") return <About navigate={navigate} />;
    const blogMatch = path.match(/^\/blog\/([^/]+)$/);
    if (blogMatch) {
      return <BlogPost slug={blogMatch[1]} navigate={navigate} />;
    }
    if (path === "/blog") return <Blog navigate={navigate} />;
    if (path === "/courses") return <CoursesPage navigate={navigate} />;
    if (path === "/faq") return <FAQ />;
    if (path === "/reviews") return <Reviews />;
    if (path === "/contact") return <Contact />;
    if (path === "/privacy-policy") return <PrivacyPolicy />;
    if (path === "/terms") return <TermsOfService />;
    return <HomePage navigate={navigate} />;
  };

  return (
    <>
      <PageSEO pathname={path} course={course} />

      {/* ✅ Navbar only if NOT legal pages */}
      {!hideLayout && (
        <Navbar navigate={navigate} currentPath={path} />
      )}

      {renderPage()}

      {/* ✅ Footer only if NOT legal pages */}
      {!hideLayout && <Footer navigate={navigate} />}
    </>
  );
}

export default App;